/**
 * @Author: yxp
 * @Date:   2017-07-11 17:07:35
 * @Last modified by:   yxp
 * @Last modified time: 2017-09-12 11:09:70
 */

import LgSelects from '@/components/login_forms/selects';
import BackHome from '@/components/back_home/back_home';
import config, { AREAS } from '@/constants/login';
import LoginSvc from '@/services/login';
import {
  Search2objFilter as search2obj,
  Obj2searchFilter as obj2search,
} from 'Russel';
import _ from 'lodash';

export default {
  data() {
    return {
      selects: AREAS,
      configType: 'common',
      area: AREAS[0].value,
      phone: '',
      password: '',
      protocol: !1,
      passwordShowed: !0,
      validators: {},
      submitting: !1,
      searchObj: search2obj(location.search),
    };
  },
  computed: {
    config() {
      return _.extend({}, config.common, config[this.configType]);
    },
    phoneRegex() {
      return (_.find(AREAS, { value: this.area }) || AREAS[0]).regex;
    },
    phoneError() {
      return this.getError(this.validators.phone, {
        required: '请输入手机号',
        pattern: '请输入正确的手机号',
        exist: '手机号不存在',
        deleted: '手机号不存在',
      });
    },
    passwordError() {
      return this.getError(this.validators.password, {
        required: '请输入密码',
      });
    },
    formInvalid() {
      return _.find(this.validators, item => !item.$valid);
    },
    formattedSearch() {
      const searchObj = {
        ...this.searchObj,
      };
      if (this.phone) searchObj.phone = this.phone;
      if (this.area) searchObj.area = this.area;
      if (this.code) searchObj.code = this.code;
      if (this.protocol) searchObj.protocol = 1;
      return `?${obj2search(searchObj)}`;
    },
  },
  methods: {
    togglePassword() {
      this.passwordShowed = !this.passwordShowed;
    },
    generate() {
      this.configType = this.searchObj.config || 'common';
      this.phone = this.searchObj.phone || '';
      this.area = this.searchObj.area || '';
      this.code = this.searchObj.code || '';
      this.protocol = !!this.searchObj.protocol;
    },
    checkPhone() {
      const areaCode = this.area.replace('+', '');

      return LoginSvc.checkPhone(this.config.checkReq, { area_code: areaCode, phone: this.phone });
    },
    checkPhoneV2() {
      const areaCode = this.area.replace('+', '');

      return LoginSvc
        .checkPhoneV2(this.config.checkReq, { area_code: areaCode, phone: this.phone });
    },
    checkProtocol() {
      return LoginSvc.checkProtocol(this.config.protocolReq,
        { area_code: this.area, phone: this.phone });
    },
    getError(validator, rule = {}) {
      if (!validator || !validator.$touched || validator.$valid) return '';
      let error;
      _.find(validator.$errors, (item, key) => {
        if (item) error = key;
        return item;
      });
      return rule[error] || '';
    },
    getFormInvalid(formNames = []) {
      return _.some(formNames, name => this.validators[name] && !this.validators[name].$valid);
    },
    goRegister() {
      location.href = `${location.origin}/backend/register/${this.formattedSearch}`;
    },
    goLogin() {
      location.href = `${location.origin}/backend/login/${this.formattedSearch}`;
    },
    goReset() {
      location.href = `${location.origin}/backend/reset/${this.formattedSearch}`;
    },
  },
  components: {
    LgSelects,
    BackHome,
  },
  watch: {
    phone() {
      if (this.checkPhoneDisabled) return;
      this.$nextTick(() => {
        if (!this.validators.phone.$errors.pattern) {
          this.checkPhoneV2().then(({ exists, deleted }) => {
            this.validators.phone.$errors.exist = !exists;
            this.validators.phone.$errors.deleted = deleted;

            this.validators.phone.$valid = exists && !deleted;
          });
          this.checkProtocol().then((read) => {
            if (read) this.protocol = !0;
          });
        }
      });
    },
  },
  created() {
    this.generate();
    this.area = AREAS[0].value;
  },
};



// WEBPACK FOOTER //
// ./src/mixins/login.js